import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../../../../@casino/ui/title';
import {useRouter} from '../../../../../@casino/useRouter';
import Event from '../../components/event';
import Gamer from '../../components/gamer';
import Statistics from '../../components/statistics';
import Users from '../../components/users';
import { setViewGroups } from '../../store/thunk/setGetViewGroup';
import { setGetBetAction, setGetEventHistoryListAction, setGetGamerInformationAction, setGetGamerListAction, setGetOperatorDetalizationAction, setGroupsViewAction, setGroupsAction } from '../../store/action';
import { setGetCreditHisotry } from '../../store/thunk/setGetCreditHistory';
import {getDate} from '../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCasino from '../../../../../@casino/ui/table';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    colorFFF: {
        color: '#fff',
    },
    divider: {
        height: 1, background: 'rgb(176, 176, 176)', marginTop: 12, marginBottom: 20
    },
}))

const ViewGroup = () => {
   

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'event_date', label: 'Дата'},
    { id: 'recipient', label: 'Получатель'},
    { id: 'amount', label: 'Сумма'},
    { id: 'balance', label: 'Баланс до'},
];

const getRows = (data) => {
    return data.map((item) => {
        return {
            id: item.id,
            event_date: getDate(item.event_date),
            recipient: item.group_name,
            amount: new Intl.NumberFormat('ru-RU').format(item.amount) + ' ₽',
            balance: new Intl.NumberFormat('ru-RU').format(item.balance) + ' ₽',
        }
    })
} 
    const classes = useStyles();
    const router = useRouter();
    const dispatch = useDispatch();
    const {id} = router.match.params;

    React.useEffect(() => {
        dispatch(setGetBetAction([]))
        dispatch(setGetEventHistoryListAction({
            list: [],
            count: 1
        }));
        dispatch(setGetGamerInformationAction({
            count_gamer: 0
        }));
        dispatch(setGetGamerListAction({
            list: [],
            count: 1
        }));
        dispatch(setGetOperatorDetalizationAction([]));
        dispatch(setGroupsViewAction({}));
        dispatch(setGroupsAction({}));
    }, [])
    
    const view = useSelector(state => state.groups.view);

    React.useEffect(() => {
        dispatch(setViewGroups({
            id
        }));   
    }, [id])

    React.useEffect(() => {
        dispatch(setGetCreditHisotry({
            search: view.groups,
            page: 1,
            rowsPerPage: 10
        }))
    }, [view])

    
    const history = useSelector(state => state.groups.history);
    const rows = React.useMemo(() => {
        return getRows(history.list)
    }, [history.list])

    return (
        <div style={{padding: 20, paddingBottom: 0, paddingTop: 0, height: '100%', overflowY: 'auto'}}>
            <Title label={`Информация о ${view.groups}`}/>
            {
                !!view.groups &&
                <>
                    <Users groups={view.groups} />
                    <Statistics groups={view.groups}/>
                    <Gamer groups={view.groups}/>
                    <Event groups={view.groups}/>
                    <div className={classes.wrapBlock}>
                        <span className={classes.colorFFF}>История банк-лимита</span>
                        <div className={classes.divider}></div>
                        <TableCasino 
                        pagination
                        allPage={history.page}
                            width={800}
                            perPage={10}
                            columns={columns}
                            rows={rows}
                            changePage={(v) => dispatch(setGetCreditHisotry({
                                page: +v.page+1,
                                rowsPerPage: v.rowsPerPage,
                                search: view.groups
                            }))}
                            changeRowsPerPage={(v) => dispatch(setGetCreditHisotry({
                                page: +v.page + 1,
                                rowsPerPage: v.rowsPerPage,
                                search: view.groups
                            }))}
                        />            
                    </div>
                </>
            }
            
        </div>
    )
}

export default ViewGroup;